import React from 'react';
import Hero from '../components/Hero';
import ServicesPreview from '../components/ServicesPreview';
import AboutPreview from '../components/AboutPreview';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <div data-testid="home-page">
      <Hero />
      <ServicesPreview />
      <AboutPreview />
      <Testimonials />
      <CTASection />
    </div>
  );
};

export default Home;
